import { Box, Typography } from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../../../../store/Index";

interface BookingLink {
  id?: string;
  title: string;
  url: string;
}

interface StreamsSectionProps {
  isEventProposal?: boolean;
  previousBookingLinks?: BookingLink[];
}

export default function StreamsSection({
  isEventProposal,
  previousBookingLinks = [],
}: StreamsSectionProps) {

  const reduxTheme = useSelector((state: RootState) => state.theme);
  
  if (previousBookingLinks.length === 0) {
    return (
      <Box sx={{ mt: 4 }}>
        <Typography
          variant="h4"
          sx={{ fontWeight: 600, mb: 3, textAlign: "left" }}
        >
          {isEventProposal
            ? "Previous Event Streams"
            : "Previous Service Streams"}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          No previous booking links have been added yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 4 }}>
      <Typography
        variant="h6"
        sx={{ fontWeight: 600, mb: 3, textAlign: "left" }}
      >
        {isEventProposal
          ? "Previous Event Streams"
          : "Previous Service Streams"}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 4,
        }}
      >
        {previousBookingLinks.map((stream, index) => (
          <Box key={index} sx={{ width: 300, textAlign: "center" }}>
            {/* QR Code */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 1,
                borderRadius: 2,

                p: 2,
                backgroundColor: "rgba(255,255,255,0.03)",
              }}
            >
              <QRCodeCanvas
                value={stream.url}
                size={80}
                bgColor="transparent"
                fgColor={reduxTheme.primary_colors[400]}
                includeMargin={true}
              />
            </Box>

            {/* Link Title */}
            <Typography
              variant="body2"
              sx={{
                color: reduxTheme.primary_colors[400],
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: 500,
                wordBreak: "break-word",
              }}
              component="a"
              href={stream.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {stream.url}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
